// extracted by mini-css-extract-plugin
export default {"main":"Licenses_main__QlDv6","boxCont":"Licenses_boxCont__lyyGs","swiperSlide":"Licenses_swiperSlide__5yQrp","box":"Licenses_box__7-iOS"};